import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  UpdateTrashBinBusinessRequest,
  UpdateTrashBinBusinessSuccessResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/trashBinManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';

/**
 * UpdateTrashBinBusinessUseCase
 */
export class UpdateTrashBinBusinessUseCase {
  /**
   * ゴミ箱内の取引情報のフラグを操作するUseCase
   * @param repository - ゴミ箱のリポジトリ
   * @param trashBinBusinessIdArray - 更新する取引情報のID一覧
   * @param isTrashFlag - 変更するフラグ
   */
  static async Execute(
    repository: ITrashBinRepository,
    trashBinBusinessIdArray: Array<string>,
    isTrashFlag: boolean
  ): Promise<INetworkResult<UpdateTrashBinBusinessSuccessResponseInfo, IError>> {
    const request: UpdateTrashBinBusinessRequest = {
      updateTrashBinBusinessIdArray: trashBinBusinessIdArray,
      isTrashFlag: isTrashFlag,
    };
    const networkResult = await repository.updateTrashBinBusiness(request);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
